import { Link } from "react-router-dom";
import { Dropdown } from "./Dropdown";
import { useContext } from "react";
import { AuthenticationContext } from "../../context/auth";
import StatusMessage from "../statusMessage/StatusMessage";


export function LeftSideMenu({ children, active }) {
  const { logout } = useContext(AuthenticationContext);
  let superAdmin = sessionStorage.getItem("superuser") === "true" || false;
  let doctor = sessionStorage.getItem("doctor") === "true" || false;
  let admin = !superAdmin && !doctor;
  let name = sessionStorage.getItem("name");

  /* NOTE - This describes the left side menu items and the permissions of each */
  let sideBarItems = [
    {
      name: "La Alacena",
      icon: "fas fa-cogs",
      admin: true,
      superAdmin: true,
      items: [
        {
          name: "Artículos",
          icon: "fa fa-book",
          link: "articles",
          admin: true,
        },
        {
          name: "Videos",
          icon: "fa fa-youtube-play",
          link: "videos",
          admin: true,
        },
        {
          name: "Pódcasts",
          icon: "fa fa-microphone",
          link: "podcasts",
          admin: true,
        },
      ],
    },
    {
      name: "Tienda de suplementación",
      icon: "fas fa-store",
      admin: true,
      superAdmin: true,

      items: [
        {
          name: "Productos",
          icon: "fas fa-prescription-bottle",
          link: "products",
          admin: true,
        },
        {
          name: "Pedidos",
          icon: "fas fa-truck",
          link: "orders",
          admin: true,
        },
      ],
    },
    {
      name: "Gestión Usuarios",
      icon: "fas fa-cogs",
      admin: true,
      superAdmin: true,

      items: [
        {
          name: "Nutricionistas",
          icon: "fa fa-user-md",
          link: "nutritionists",
          admin: true,
        },
        {
          name: "Consultas",
          icon: "fas fa-comments",
          link: "consultation",
          admin: true,

        },
        {
          name: "Usuarios",
          icon: "fas fa-user-cog",
          link: "users",
          admin: true,
        },
      ],
    },
    {
      name: "Master Nutrición",
      admin: true,
      superAdmin: true,
      icon: "fas fa-cogs",
      items: [
        {
          name: "Recetas",
          icon: "fa fa-cutlery",
          link: "recipes",
          admin: true,
        },
        {
          name: "Alimentos",
          icon: "fa fa-shopping-basket",
          link: "aliments",
          admin: true,
        },
        {
          name: "Carga BBDD",
          icon: "fas fa-user-cog",
          link: "management",
        },
      ],
    },
    //NEW @alreylz "SECCIONES SOLO PARA EL NUTRICIONISTA"
    {
      name: "La Consulta",
      icon: "fas fa-cogs",
      doctor: true,
      superAdmin: false,
      items: [
        {
          name: "Consultas",
          icon: "fas fa-comments",
          link: "consultation",
          doctor: true,
        },
        {
          name: "Usuarios",
          icon: "fas fa-user-cog",
          link: "users",
          doctor: true,
        },
      ],
    },
    {
      name: "Nutrición",
      doctor: true,
      icon: "fas fa-cogs",
      items: [
        {
          name: "Artículos",
          icon: "fa fa-book",
          link: "articles",
          doctor: true,
        },
        {
          name: "Videos",
          icon: "fa fa-youtube-play",
          link: "videos",
          doctor: true,
        }

        , {
          name: "Recetas",
          icon: "fa fa-cutlery",
          link: "recipes",
          doctor: true,

        },
        {
          name: "Alimentos",
          icon: "fa fa-shopping-basket",
          link: "aliments",
          doctor: true,
        },
      ],
    },
    {
      name: "Mi Cuenta",
      icon: "fas fa-cogs",
      admin: false,
      doctor: true,
      superAdmin: true,
      items: [
        {
          name: "Mis datos",
          icon: "fas fa-user-tie",
          link: "nutritionist/misDatos",
          doctor:true
        },
        {
          name: "Mi cuenta",
          icon: "fas fa-user-tie",
          link: "nutritionist/miCuenta",
          doctor:true

        },
        {
          name: "Mi disponibilidad",
          icon: "fas fa-user-tie",
          link: "nutritionist/miDisponibilidad",
          doctor:true

        },
      ]
    },
    ///------------------
    {
      name: "Administración",
      icon: "fas fa-cogs",
      admin: true,
      doctor: false,
      superAdmin: true,
      items: [
        {
          name: "Admins",
          icon: "fas fa-user-tie",
          link: "admins",
        },
        {
          name: "Mi Cuenta",
          icon: "far fa-address-card",
          link: "myAccount",
          admin: true,
          doctor: true,
        },
        {
          name:"Avanzado - DevUtils",
          icon: "fa fa-gamepad",
          link: "devUtils",
          admin:false,
          doctor:false,
          superAdmin:"true"

        },
        {
          name: "Estadísticas",
          icon: "fas fa-chart-bar",
          link: "stats",
        },
        {
          name: "Logs",
          icon: "fas fa-chart-bar",
          link: "logs",
        },
      ],
    },
  ];

  function activeNavBar(e) {
    e.preventDefault();
  }

  return (
    <>
      <div className="left side-menu">
        <div className="sidebar-inner slimscrollleft">
          <div className="user-box">
            <div>
              <img
                src="./img/munchFit.png"
                alt="munchFit logo"
                className="img-responsive center-block pb-3 logo-adjust"
              />
            </div>
            <p className="p-5 ">Bienvenido, {name} </p>
            <p className="p-3">
              {superAdmin ? "Superadmin" : admin ? "Admin" : doctor ? "Nutricionista"
                : "tipo de usuario no soportado"}
            </p>
            <ul className="list-inline">
              <li
                id="liHome"
                onClick={(event) => activeNavBar(event, "articles.html")}
                className="icon-button"
                title="Home"
              >
                <i className="fas fa-home fa-2x"></i>
              </li>
              <li
                id="liLogout"
                onClick={logout}
                data-toggle="tooltip"
                className="icon-button"
                title="LogOut"
              >
                <i className="fas fa-power-off fa-2x"></i>
              </li>
            </ul>
          </div>
          <div id="sidebar-menu">
            <ul>
              <hr className={"menuSeparator"} />
              {sideBarItems.map((topLevel, index) => {
                if (
                  (topLevel.admin && admin) ||
                  (topLevel.doctor && doctor) ||
                  (topLevel.superAdmin && superAdmin)
                ) {
                  return (
                    <Dropdown
                      key={index}
                      trigger={
                        <li key={topLevel.name}>
                          <a className="waves-effect">
                            <i className={topLevel.icon}></i>
                            <span>{topLevel.name}</span>
                          </a>
                        </li>
                      }
                    >
                      {topLevel.items.map((item) => {
                        if (
                          (item.admin && admin) ||
                          (item.doctor && doctor) ||
                          (topLevel.superAdmin && superAdmin)
                        ) {
                          return (
                            <li key={item.name}>
                              <Link
                                to={`/${item.link}`}
                                style={{ paddingLeft: "15%" }}
                                className={
                                  "waves-effect" +
                                  (active === item.link && " active")
                                }
                              >
                                <i className={item.icon}></i>
                                <span>{item.name}</span>
                              </Link>
                            </li>
                          );
                        } else {
                          return "";
                        }
                      })}
                    </Dropdown>
                  );
                }
              })}
            </ul>
            <div className="clearfix"></div>
          </div>
          <div className="clearfix"></div>
        </div>
      </div>
      <div className="content-page" style={{ height: "100%" }}>
        <>
          <StatusMessage />
          {children}
        </>
      </div>
    </>
  );
}
